import React, { useState } from 'react';
import '../dashboard/Dashboard.css'; // Import the CSS file for styles

const Multisteppage: React.FC = () => {
  const [selectedStep, setSelectedStep] = useState<string>('Choose Step');
  const steps = [
    'Choose Step',
    'Registration',
    'Signup',
    'Subscribe',
    'Download',
    'Deposit',
    'FTD',
    'AddToCart',
    'BeginCheckout',
    'Purchase',
    'Order',
    'FirstOpen',
    'Open',
    'Call',
    'Contact',
    'OutboundClick',
    'Other'
  ];

  const baseUrl = 'http://secure.bidvertiser.com/performance/pc.dbm?ver=1.0&AID=338336124&CLICKID={"{BV_CLICKID}"}&revenue={"{REVENUE}"}';
  const postbackUrl = selectedStep !== 'Choose Step' ? `${baseUrl}&ctype=${selectedStep}` : baseUrl;

  return (
    <div className="dashboard-container" style={{ height:'80%',padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '100%', margin: 'auto', backgroundColor: '#fff', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}>
      <div className="content-wrapper" style={{width:'60%'}}>
        <h2 className="title" style={{fontSize:'14px'}}>Global Postback Setup:</h2>
        
        <div style={{marginLeft:'30px'}}>
        <h3 className="subheading" style={{fontSize:'12px'}}>Multi-Step Conversion</h3>
        <p className="description">
          Multi-Step conversion tracking allows you to track several conversions for the same click. For example - <strong>registration</strong> and then at a later point - <strong>purchase</strong>. To integrate with the Global Postback - add an additional parameter named "ctype" with a pre-configured value.
        </p>

        <h4 className="subheading" style={{fontSize:'12px'}}>Choose conversion type to be added to your Global Postback:</h4>
        <select
          value={selectedStep}
          onChange={(e) => setSelectedStep(e.target.value)}
          className="dropdown"
        >
          {steps.map((step, index) => (
            <option key={index} value={step}>{step}</option>
          ))}
        </select>

        <div className="postback-url" style={{fontSize:"12px", marginTop:'20px'}}>
          {postbackUrl}
        </div>

        <p className="note" style={{fontSize:'12px'}}>
        CTYPE value is limited to the values above! <br></br>
        Any other type will not be processed.        </p>
        </div>
        
      </div>
    </div>
  );
};

export default Multisteppage;
